<template>
  <div class="main">
      <img class="imagem" :src="`data:image/png;base64, ${this.imagem}`" />
      <h1>Abrir Chamado</h1>
      <p>Escaneie o código QR para abrir um chamado para esse equipamento</p>
  </div>
</template>

<script>

import api from '@/services/api';

export default {
  name: 'Etiquetas',
  data() {
    return {
      recnum: null,
      imagem: '',
    };
  },
  async created() {
    const { recnum } = this.$route.params;
    this.recnum = recnum;
    const retorno = await api.get(`/api/equipamentos/etiqueta/${this.recnum}`);
    this.imagem = retorno.data.data;

    window.addEventListener('message', () => window.print(), false);
  },
};
</script>

<style>
.imagem {
  width: 150px;
}

.main {
  background-color: #FFFFFFFF;
  max-width: 320px;
  padding: 1.075em;
  border-radius: 1.35em;
  text-align: center;
  margin: auto;
  margin-top: 1.075em;
}
</style>
